import React from 'react';

const Quercus = () => {
  return <img alt='QUERCUS' style={{height: '100%', marginRight: '30px'}} src='images/Logo-QUERCUS.png'/>;
};

export default Quercus;